<template>
    <div>
        <app-header></app-header>
        <div class="featured-courses">
            <div class="featured-course course-item">
                <div class="course-thumb set-bg" style="background: url('@/assets/f-1.jpg')">
                    <div v-html="PRODUCTS_SHOW.link"></div>
                </div>
                <div class="row">
                    <div class="col-lg-6 offset-lg-6 pl-0">
                        <div class="course-info">
                            <div class="course-text">
                                <div class="fet-note">{{PRODUCTS_SHOW.cat_id[0].name}}</div>
                                <h5>{{PRODUCTS_SHOW.name}}</h5>
                                <p>{{PRODUCTS_SHOW.description}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppHeader from '@/components/header/'
    import { mapGetters } from 'vuex'
    export default {
        props: {
            id: {
                type: String,
                default: '1'
            },
        },
        computed: {
            ...mapGetters([
                'PRODUCTS_SHOW'
            ])
        },
        components: {
            AppHeader
        },
    }
</script>

<style scoped>
    .featured-courses{
        position: relative;
        margin-top: 120px;
    }
    .header-section{
        background: #3A3B40;
    }
    .container{
        margin-top: 140px;
    }
    .course-thumb{
        position: relative;
        text-align: center;
        margin-top: 5%;
    }
</style>